import { createContext, useCallback, useContext, useState } from "react";
import ContactModal from "@/components/ContactModal";

const ContactModalContext = createContext({
  open: () => {},
  close: () => {},
});

export const ContactModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <ContactModalContext.Provider value={{ open, close }}>
      {children}
      <ContactModal open={isOpen} onOpenChange={setIsOpen} />
    </ContactModalContext.Provider>
  );
};

export const useContactModal = () => useContext(ContactModalContext);
